/* eslint-disable react/display-name */
import React, { memo } from 'react';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import WeekModel from './weekModel';
import { WeekItemsStyled, WeekItemStyled, WeekStyled } from './styled';

const Week = memo(({ style = {} }: { style?: React.CSSProperties }) => {
  const { localization } = usePageWrapperData();
  const { locale, lang } = localization;
  const { weekDays } = new WeekModel({ locale, lang });

  return (
    <WeekStyled style={style}>
      <WeekItemsStyled>
        {weekDays.map((item: string) => (
          <WeekItemStyled key={`week_${item}`} className="week-item">
            {item}
          </WeekItemStyled>
        ))}
      </WeekItemsStyled>
    </WeekStyled>
  );
});

export default Week;
